export default "__VITE_ASSET__CvsgigY3__"